import { JOBS_DELETED_EVENT } from "../../types/events/jobsDeleted.js";
import { request } from "../../utils/request.js";
import { locationRestJobsDelete } from "../../wp-api/jobs.delete.js";
import { fetchStatus } from "../fetchStatus.js";
/**
 * Delete jobs by e.g. type. This is similar to a "Cancel" button.
 */ async function deleteJobs(params) {
    const response = await request({
        location: locationRestJobsDelete,
        params
    });
    document.dispatchEvent(new CustomEvent(JOBS_DELETED_EVENT, {
        detail: {
            params,
            response
        }
    }));
    await fetchStatus(true);
    return response;
}
export { deleteJobs };
